import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getMeetingsSettingsLink } from 'MeetingsAdmin/utils/utils';
//@ts-expect-error untyped import
import { getMeetingsUserForCurrentUser } from '../../selectors/MeetingsUsersSelectors';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function FixSchedulingPageWarning() {
  const meetingsUser = useSelector(getMeetingsUserForCurrentUser);
  if (meetingsUser) {
    const schedulingPagesEnabled = meetingsUser.get('schedulingPageEnabled');
    return !schedulingPagesEnabled ? /*#__PURE__*/_jsxs(Alert, {
      type: "warning",
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "calendarView.fixSchedulingWarning.title"
      }),
      "data-test-id": "scheduling-page-ui-alert",
      padding: "500",
      marginBlockEnd: "400",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "calendarView.fixSchedulingWarning.body"
      }), /*#__PURE__*/_jsx(Button, {
        external: true,
        href: getMeetingsSettingsLink('schedulingPageEnabled=true'),
        size: "small",
        use: "tertiary",
        marginInlineStart: "600",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "calendarView.fixSchedulingWarning.action"
        })
      })]
    }) : null;
  }
  return null;
}